export function getUserDisplayName(user) {
  const preferredValue = [
    user?.name,
    user?.username,
    user?.email,
    user?.sub,
    user?.uid,
  ].find((value) => typeof value === 'string' && value.trim());

  return preferredValue?.trim() ?? '';
}
